export * from '@primeuix/themes/material/inputotp';
export { default } from '@primeuix/themes/material/inputotp';
